import React from "react";
import styled from "styled-components";

function PrivacyPolicyPage(): React.JSX.Element {
  const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    padding: 0;
    margin: 0;
    overflow: hidden;
  `;

  return (
    <Container data-testid="terms-of-service">
      <iframe
        src="https://app.termly.io/policy-viewer/policy.html?policyUUID=e37a1c30-fade-409f-8f77-19870f540841"
        title="Privacy Policy"
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
        }}
      />
    </Container>
  );
}

export default PrivacyPolicyPage;
